import { CartProductType, type CartProduct } from '@/app/[locale]/order/_context/order-flow-context'

/** Total count of extra modules selected on all `ANNUAL_PROGRAM_FAMILY` lines. */
export function familyModuleCount(cartProducts: CartProduct[]): number {
	return cartProducts.reduce((sum, p) => {
		if (p.type !== CartProductType.ANNUAL_PROGRAM_FAMILY) return sum
		return sum + (p.data.extraModuleIds?.length ?? 0)
	}, 0)
}
